/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIUnitEconomicsCostListResponse {
    getFixupPrototypeFunction() { return AIUnitEconomicsCostListResponse.fixupPrototype; }

    static newInstance(model: Partial<AIUnitEconomicsCostListResponse>): AIUnitEconomicsCostListResponse {
        let obj = Object.assign(new AIUnitEconomicsCostListResponse(), model);
        AIUnitEconomicsCostListResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIUnitEconomicsCostListResponse>): AIUnitEconomicsCostListResponse {
        if (!model) return null;
        return AIUnitEconomicsCostListResponse.newInstance(<AIUnitEconomicsCostListResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIUnitEconomicsCostListResponse) {
        if (!obj) return;

        models.AIUnitEconomicsCostListResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIUnitEconomicsCostListResponse): boolean {
        Object.setPrototypeOf(obj, AIUnitEconomicsCostListResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.next_list_context) {
            models.ListContext.fixupPrototype(this.next_list_context);
        }
    }

    /**
     * List of result identifiers
     */
    results: Array<string>;

    /**
     * List context
     */
    next_list_context: models.ListContext;

}
